import React, { FunctionComponent } from 'react';
import { FitnessActivity } from './FitnessActivity';
import { FitnessTable } from './FitnessTable';

import { notNull } from '../../../utils/typeGuards';
import styles from './FitnessMessage.scss';
import {
  FitnessActivity as FitnessActivityData,
  FitnessApplicationSettings,
  MeasurementSystem,
  Distance,
  Duration,
  DistanceUnit,
} from '../../../../types/__generated__';

interface Props {
  message: string | null | undefined;
  caption: string;
  fitness: FitnessActivityData;
  settings?: Pick<
    FitnessApplicationSettings,
    'showDuration' | 'showDistance' | 'showElevation' | 'measurementSystem'
  >;
}

function displayPreferenceGuard(
  displayValue: any,
  guard?: boolean | null,
  value?: Duration | Distance | null,
) {
  return guard ? value && displayValue : null;
}

export const FitnessMessage: FunctionComponent<Props> = ({
  message,
  caption,
  fitness: { activityType, duration, distance, elevation, title = '' },
  settings: { showDuration, showDistance, showElevation, measurementSystem } = {
    showDuration: true,
    showDistance: true,
    showElevation: true,
    measurementSystem: MeasurementSystem.Metric,
  },
}) => {
  const headings = [
    displayPreferenceGuard('Time', showDuration, duration),
    displayPreferenceGuard('Distance', showDistance, distance),
    displayPreferenceGuard('Elevation', showElevation, elevation),
  ].filter(notNull);

  const elevationElement =
    elevation &&
    measurementSystem &&
    `${elevation.value} ${distanceUnitMap[elevation.unit]}`;

  const rows = [
    [
      displayPreferenceGuard(duration, showDuration, duration),
      displayPreferenceGuard(distance, showDistance, distance),
      displayPreferenceGuard(elevationElement, showElevation, elevation),
    ],
  ].map(row => row.filter(notNull));

  return (
    <div>
      {activityType ? (
        <FitnessActivity activityType={activityType} title={title ?? ''} />
      ) : null}
      <div className={styles.message}>{message}</div>
      <FitnessTable caption={caption} headings={headings} rows={rows} />
    </div>
  );
};

const distanceUnitMap = {
  [DistanceUnit.Metres]: 'm',
  [DistanceUnit.Feet]: 'ft',
};
